module.exports = __webpack_public_path__ + "static/media/person3.4d30b1a1.jpeg";